import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";
import css from "./Category.module.css";

export default function Category({ category, onClick }) {
  const location = useLocation();
  const { imageUrl, name, categoryId } = category;

  if (location?.pathname === "/shops") {
    return (
      <a
        className={css.card}
        style={{ backgroundImage: `url(${imageUrl})` }}
        href={`/shops?g=${categoryId}`}
        onClick={onClick}
      >
        <span className={css.title}>{name}</span>
      </a>
    );
  }

  return (
    <Link
      className={css.card}
      style={{ backgroundImage: `url(${imageUrl})` }}
      to={`/shops?g=${categoryId}`}
      onClick={onClick}
    >
      <span className={css.title}>{name}</span>
    </Link>
  );
}

Category.propTypes = {
  category: PropTypes.shape({
    name: PropTypes.string.isRequired,
    categoryId: PropTypes.number.isRequired,
    imageUrl: PropTypes.string,
  }),
  onClick: PropTypes.func,
};
